
import { defineComponent } from 'vue'
import Processor from '@/components/Processor.vue'

export default defineComponent({
  name: 'TPSlider',
  props: {
    level: {
      type: Number,
      default: 0,
    },
  },
  components: {
    'tp-processor': Processor,
  },
  methods: {
    isFull(index: Number): boolean {
      if (this.level >= index) {
        return true
      }

      return false
    }
  }
})
